import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import { fitBounds } from "google-map-react/utils"
import { connect } from "react-redux"
import { IS_BROWSER, DOCUMENT, WINDOW } from "constants/environment"
import { getGoogleMapsApi } from "apis/google-maps"
import { dealerInfo } from "apis/dealer-search"
import {
  withRadium,
  gtmEvent,
  ConnectLocation,
  DetectCompact,
  SearchParams
} from "higher-order-components"
import { selectors } from "store/actions/environment"
import { noop, scrollToNode } from "utils"
import exposeGlobal from "apis/expose-global"
import { findDOMNode } from "react-dom"
import { LoaderIcon, MapWithMarkers } from "components"
import { gtmMapCampaignBlockActionTypes } from "store/gtm-events"
import HeaderSectionMapLocationContainer from "./header-section"
import LocationsSectionMapLocationContainer from "./locations-section"
import fetchAPI from "AtomicUtils/fetchAPI"

class MapLocationContainer extends PureComponent {
  constructor(props) {
    super(props)
    // locationState comes from backend
    this.state = {
      fresh: true,
      activeIndex: -1,
      activeIndexOfStates: 0,
      locations: props.locations || [],
      originalLocations: [],
      hovers: [],
      searchInput: {
        postcode: props.locationState.postcode ? String(props.locationState.postcode) : ""
      },
      map: {
        center: {
          lat: props.locationState.latitude || -37.8390361,
          lng: props.locationState.longitude || 144.9997397
        },
        zoom: props.defaultZoom
      },
      defaultCenter: { lat: -37.8390361, lng: 144.9997397 },
      selectedFilters: props.initialSelectedFilters || {
        sales: true,
        service: false,
        parts: false
      },
      didEdit: false,
      filters: [
        { name: "Sales", slug: "sales" },
        { name: "Service", slug: "service" },
        { name: "Parts", slug: "parts" }
      ],
      dealerCode: null
    } // For an unknown reason, component didn't update by chaning inside the json, so this helps the component to be updated // This is for showing the first impression before entering anything
  }

  // Handling filters of Sales/Service/Parts
  handleToggleFilter = (option) => {
    let eventID = "FED-FAD-"
    switch (option.slug) {
      case "sales":
        eventID += "002"
        break
      case "service":
        eventID += "004"
        break
      case "parts":
        eventID += "006"
        break
      default:
        return null
    }
    this.props.gtmEvent({
      gtmID: this.props.gtmMapping.CHECK_DEALERTYPE,
      gtmPayload: { dealerType: option.name, eventID: eventID }
    })
    const selectedFilters = { ...this.state.selectedFilters }
    Object.keys(selectedFilters).map((key) => {
      selectedFilters[key] = false
    })
    selectedFilters[option.slug] = !selectedFilters[option.slug]
    this.setState({ selectedFilters }, () => {
      this.props.search.pushParam({ department: option.slug })
      // this.updateLocations()
      let optionName = option.slug.toUpperCase()
      let indexVal = ''
      if (optionName == 'SALES') indexVal = 0
      if (optionName == 'SERVICE') indexVal = 1
      if (optionName == 'PARTS') indexVal = 2
      localStorage.setItem('activeTabIndex', indexVal)

      this.updateLocationsOnFiltersToggle()
    })
  }

  componentDidMount() {
    // TODO: WE NEED TO GET RID OF THIS API!
    exposeGlobal("getSelectedLocation", () => ({
      locations: this.state.locations,
      selectedLocation: this.state.locations[this.state.activeIndex]
    }))

    // Initial Load when we have a select states
    if (this.props.searchType === "select") {
      if (this.props.dealerLocations.length > 0) {
        const newDealers = this.props.dealerLocations.map(item => ({
          ...item,
          lat: Number(item.lat),
          lng: Number(item.lng)
        }))
        this.setState(
          {
            locations: newDealers,
            backupLocations: newDealers
          },
          () => {
            this.createUniqueStates(() => {
              if (WINDOW.localStorage && WINDOW.localStorage.getItem("state")) {
                this.handleSelectDropDown(
                  {
                    name: WINDOW.localStorage.getItem("state")
                  },
                  true
                )
              } else {
                if (!this.props.compact) {
                  this.calculateBoundsAndZommLevelBasedOnLocations()
                }
              }
            })
          }
        )
      }
    }

    // Initial Load when we have a search dealer input
    if (this.props.searchType === "search") {
      const initialDepartment = this.props.search.query.department
      const departments = { sales: false, service: false, parts: false }
      if (initialDepartment) {
        departments[initialDepartment] = true
        this.setState({ selectedFilters: departments })
      }
      setTimeout(() => {
        if (this.state.searchInput.postcode != "") {
          console.log('map location initial load')
          console.log(this.state.searchInput)

          this.updateLocationInSearchInput(this.state.searchInput)
        }
        if (this.props.scrollToMain) {
          scrollToNode(findDOMNode(this.node))
        }
      }, 100)
    }

    // locations are sent by parent
    if (this.props.searchType === "nothing") {
      setTimeout(() => {
        // Click on the first one with scrolling to the first one
        this.handleClickOnLocation(0, false)
        if (!this.props.compact) {
          this.calculateBoundsAndZommLevelBasedOnLocations()
        }
      }, 100)
    }
  }

  // Get Dealer
  getSelectedDealer = () => ({
    selected: this.state.locations[this.state.activeIndex],
    totalCount: this.state.locations.length
  })

  // Handle Click on Each Location Tile for Showing on the Map
  // no scrolling for nz maps (all loaded on one map)
  handleClickOnLocation = (index, scrollToActiveTileOrNot = false, callback = () => { }) => {
    // reset all hovers -> it was a bug in devices
    if (!this.props.compact) {
      this.handleMouseLeaveOnLocation()
    }
    this.setState(
      {
        activeIndex: index,
        ...(!this.state.didEdit ? { didEdit: true } : {})
      },
      () => {
        // Scroll to the right location tile
        if (scrollToActiveTileOrNot) this.handleScrollToActiveLocation()
        // Blur function closes mobile keyboard
        scrollToActiveTileOrNot && DOCUMENT && DOCUMENT.activeElement && DOCUMENT.activeElement.blur && DOCUMENT.activeElement.blur()
        // Scroll to this section for concentration
        !this.props.compact && scrollToActiveTileOrNot && scrollToNode(findDOMNode(this))
        this.props.onDealerChange(this.getSelectedDealer())

        callback()
      }
    )
  }

  // for handling mouse entering on locations to change marker to become red
  handleMouseEnterOnLocation = (index) => {
    const newLocations = this.state.locations.slice(0)
    newLocations.map((item, locationIndex) => {
      item.hover = locationIndex === index
    })
    newLocations[index] = { ...newLocations[index], hover: true }
    this.setState({ locations: newLocations, fresh: !this.state.fresh })
  }

  // for handling mouse leaving on locations to change marker to become red
  // Removed index because it was better to reset all hovers to become false
  handleMouseLeaveOnLocation = () => {
    const newLocations = this.state.locations.slice(0)
    newLocations.map((item, locationIndex) => {
      item.hover = false
    })
    this.setState({ locations: newLocations, fresh: !this.state.fresh })
  }

  // Scroll to the location which is selected
  handleScrollToActiveLocation = () => {
    if (!IS_BROWSER || !this.activeTileRef) return
    scrollToNode(findDOMNode(this.activeTileRef), {
      container: this.props.compact ? "body, html" : findDOMNode(this.detailsPanelRef)
    })
  }

  // Calculating the center of the map with zoomLevel
  calculateBoundsAndZommLevelBasedOnLocations = () => {
    if (!this.props.compact) {
      let bounds = {}
      const map = { ...this.state.map }
      if (this.state.locations.length < 1) {
        bounds.zoom = map.zoom
        bounds.center = map.center
      } else {
        const dimensions = {
          height: this.mapRef ? this.mapRef.clientHeight : 1,
          width: this.mapRef ? this.mapRef.clientWidth : 1
        }
        const allLatitudes = []
        const allLongitudes = []
        for (const marker of this.state.locations) {
          allLatitudes.push(marker.lat)
          allLongitudes.push(marker.lng)
        }
        const northWest = {
          lat: Math.max(...allLatitudes),
          lng: Math.min(...allLongitudes)
        }
        const southEast = {
          lat: Math.min(...allLatitudes),
          lng: Math.max(...allLongitudes)
        }
        if (Object.keys(northWest).every((key, index) => northWest[key] === southEast[key])) {
          bounds = { center: northWest }
          bounds.zoom = this.props.defaultZoom
        } else {
          bounds = fitBounds({ nw: northWest, se: southEast }, dimensions)
          bounds.zoom -= 1
        }
        bounds.zoom = bounds.zoom > this.props.defaultZoom ? this.props.defaultZoom : bounds.zoom
        if (!this.mapRef) delete bounds.zoom
      }
      map.zoom = bounds.zoom
      map.center = bounds.center
      // This should resolve immediately and not refetch once the api is loaded the first time
      getGoogleMapsApi().then(() => this && this.setState({ map }))
    }
  }

  updateLocations = () => {
    console.log('update locations state')
    console.log(this.state)
    const dealerTypes = Object.keys(this.state.selectedFilters)
      .map((key) => {
        if (this.state.selectedFilters[key] === true) {
          return key
        }
      })
      .filter(result => !!result)
    this.setState(
      {
        loadingLocations: true
      },
      () => {
        console.log('update locations search Input')
        console.log(...this.state.searchInput)
        console.log('update locations dealer types')
        console.log(dealerTypes)
        dealerInfo({ ...this.state.searchInput, dealerTypes })
          .then(({ response }) =>

            this.setState(
              {
                locations: response || [],
                loadingLocations: false
              },
              () => {


                if (!this.props.compact) {
                  this.calculateBoundsAndZommLevelBasedOnLocations()
                }
                if (this.props.autoSelectDealer) {
                  // Click on the first one with scrolling to the first one
                  this.handleClickOnLocation(0, false)
                } else {
                  this.setState({ activeIndex: -1 })
                }
              }
            ))
          .catch(console.warn.bind(console))
      }
    )
  }

  searchDealers = async (search) => {
    const service = '/api/dealer-search'
    await fetchAPI({
      method: "POST",
      url: service,
      body: {
        searchText: search.suburb
      }
    })
    .then(async (response) => {
      const json = await response.json()
      const { success, data } = json
        if (success) {
        const { success, data } = json
        console.log('dealer-search response map-location')
        console.log(json)
        if (success && json.data && json.data.length > 0) {
            console.log('setting dealer code')
            this.setState({
              searchInput: {
                dealerCode: json.data[0].value,
                postcode: search.postcode
              }
            },
            () => {
              this.updateLocations()
            })
          }
        }
    })
  }

  updateLocationInSearchInput = (search) => {
    if (!search) return

    console.log('updateLocationInSearchInput - map location')
    console.log('updateLocationInSearchInput - map location' + JSON.stringify(search))
    if(!search.postcode && !search.dealerCode) {
      (async () => await this.searchDealers(search))()
      search.dealerCode = this.state.dealerCode

    }
    else
    {
      this.setState(
        {
          searchInput: {
            dealerCode: search.dealerCode,
            postcode: search.postcode
          }
        },
        () => {
          this.updateLocations()
        }
      )
    }
  }

  handleSelectDropDown = (value, isOnLoad) => {
    let activeIndexOfStates = 0
    for (let i = 0; i < this.state.uniqStates.length; i += 1) {
      if (this.state.uniqStates[i].name === value.name) {
        activeIndexOfStates = i
      }
    }
    this.setState(
      {
        activeIndexOfStates
      },
      () => {
        this.handleFilterLocations(value, () => {
          if (!this.props.compact) {
            this.calculateBoundsAndZommLevelBasedOnLocations()
            // we don't want anything to be highlighted after changing state
            this.handleMouseLeaveOnLocation()
          }
        })
      }
    )
    // We don't want a GTM event to fire on first load, hence the checking.
    if (!isOnLoad) {
      this.props.gtmEvent({
        gtmID: gtmMapCampaignBlockActionTypes.SELECT_FILTER_OPTION,
        gtmPayload: { option: value.name }
      })
    }
  }

  createUniqueStates = (next) => {
    const uniqStates = ["All States"]
    for (const single of this.state.locations) {
      if (uniqStates.indexOf(single.state) <= -1) {
        uniqStates.push(single.state)
      }
    }
    this.setState(
      {
        uniqStates: uniqStates.map(item => ({ name: item }))
      },
      next
    )
  }

  handleFilterLocations = (value, next) => {
    if (
      value.name !== "All States" &&
      this.state.uniqStates.map(item => item.name).includes(value.name)
    ) {
      this.setState(
        {
          locations: this.state.backupLocations.filter(item => item.state === value.name)
        },
        () => {
          if (typeof next === "function") next()
        }
      )
    } else {
      this.setState(
        {
          locations: this.state.backupLocations
        },
        () => {
          next()
        }
      )
    }
  }

  updateLocationsOnFiltersToggle = () => {
    setTimeout(() => {
      let department = ''
      let qs = this.getUrlParameter("department")
      department = qs.toUpperCase()
      let filteredData = []

      if (!qs || qs === '') department = 'SALES'

      filteredData = this.state.originalLocations.filter((item) => {
        let departmentMatch = item.departments.find((dep) => {
          return dep.name.toUpperCase() === department
        })

        if (departmentMatch) return item
      })

      this.setState({
        locations: filteredData,
        activeIndex: -1
      })

      setTimeout(() => {
        this.calculateBoundsAndZommLevelBasedOnLocations()
      }, 250)
    }, 100)
  }

  handleNZLocations = (data, originalSet = []) => {
    // first item is active by default
    this.setState({
      locations: data,
      activeIndex: (data.length > 1) ? -1 : 0
    })

    if (originalSet.length > 0) {
      this.setState({
        originalLocations: originalSet
      })
    }

    // better in case google map isn't loaded yet
    this.mapInterval = setInterval(this.mapFunction, 100)
  }

  mapFunction = () => {
    if (typeof google === 'object' && typeof google.maps === 'object') {
      this.calculateBoundsAndZommLevelBasedOnLocations()
      clearInterval(this.mapInterval)
    }
  }

  getUrlParameter = (name) => {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    let results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  render() {
    let activeFilterIndex = 0
    for (let i = 0; i < this.state.filters.length; i += 1) {
      if (this.state.selectedFilters[this.state.filters[i].slug]) {
        activeFilterIndex = i
      }
    }
    const SearchSection = () => (
      <HeaderSectionMapLocationContainer
        heading={this.props.heading}
        description={this.props.description}
        searchInput={this.state.searchInput || {}}
        dealerSearchEndPoint={this.props.dealerSearchEndPoint}
        updateLocationInSearchInput={this.updateLocationInSearchInput}
        gtmMapping={this.props.gtmMapping}
        disableFilters={this.props.disableFilters}
        searchOverride={this.props.searchOverride}
        filters={this.state.filters}
        handleToggleFilter={this.handleToggleFilter}
        activeIndex={activeFilterIndex}
        searchType={this.props.searchType}
        dropDownDisabled={this.props.dropDownDisabled}
        handleSelectDropDown={this.handleSelectDropDown}
        activeIndexOfStates={this.state.activeIndexOfStates}
        uniqStates={this.state.uniqStates}
        dropDownLabel={this.props.dropDownLabel}
        handleNZLocations={this.handleNZLocations} />
    )
    return (
      <div
        key="MapLocationContainer"
        ref={(node) => {
          this.node = node
        }}
        style={[
          !this.props.mapFixHeight && this.props.compact
            ? styles.mapBlockContainerCompact
            : styles.mapBlockContainerNotCompact,
          this.props.mapFixHeight && { display: "block", minHeight: "1px" }, // 1px required for the map to show on Safari
          !this.props.mapFixHeight && styles.main(this.props.globalHeaderHeight)
        ]}>
        {/* Search Section Can be on top of the whole Block */}
        {/* <SearchSection /> caused infinity loop for rendering */}
        {this.props.searchType != "nothing" && this.props.displaySearchTop && SearchSection()}
        <div
          style={[
            { flex: "1 1 100%" },
            styles.locationsAndMapContainer,
            this.props.compact && styles.locationsAndMapContainerCompactMode,
            styles.map(this.props.isMapFirstInCompact, this.props.mapFixHeightStyle),
            {
              visibility:
                this.props.hideWhenNoLocation && this.state.locations.length === 0
                  ? "hidden"
                  : "visible"
            }
          ]}>
          {/* Location Section */}
          {/* On Top of Location Section we can have Search Section(Optional) */}
          <div
            style={styles.detailsPanel(this.props.showScrollbars)}
            ref={(c) => {
              this.detailsPanelRef = c
            }}>
            {!this.props.displaySearchTop && SearchSection()}
            {this.state.loadingLocations ? (
              <div style={styles.loaderContainer}>
                <LoaderIcon />
              </div>
            ) : (
                <LocationsSectionMapLocationContainer
                  entryMessage={this.props.entryMessage}
                  locations={this.state.locations.map(location =>
                    this.props.mapLocationData(location))}
                  activeIndex={this.state.activeIndex}
                  salesCTA={this.props.salesCTA}
                  serviceCTA={this.props.serviceCTA}
                  emailCTA={this.props.emailCTA}
                  getActiveTileRef={(c) => {
                    this.activeTileRef = c
                  }}
                  compact={this.props.compact}
                  handleMouseEnterOnLocation={this.handleMouseEnterOnLocation}
                  handleMouseLeaveOnLocation={this.handleMouseLeaveOnLocation}
                  handleClickOnLocation={this.handleClickOnLocation}
                  gtm={this.props.gtm} />
              )}
          </div>
          {/* Google Map Section */}
          {!(this.props.hideMapInCompact && this.props.compact) && (
            <div
              ref={(c) => {
                this.mapRef = c
              }}
              style={styles.mapPanel}>
              <MapWithMarkers
                defaultCenter={this.state.defaultCenter}
                locations={this.state.locations}
                defaultZoom={this.props.defaultZoom}
                map={this.state.map}
                activeIndex={this.state.activeIndex}
                handleClickOnLocation={this.handleClickOnLocation} />
            </div>
          )}
        </div>
      </div>
    )
  }
}

MapLocationContainer.propTypes = {
  heading: PropTypes.string,
  description: PropTypes.string,
  dealerSearchEndPoint: PropTypes.string,
  autoSelectDealer: PropTypes.bool,
  globalHeaderHeight: PropTypes.number,
  dealerLocations: PropTypes.array,
  entryMessage: PropTypes.string,
  disableFilters: PropTypes.bool,
  gtmEvent: PropTypes.func,
  defaultZoom: PropTypes.number,
  compact: PropTypes.bool,
  onDealerChange: PropTypes.func,
  searchOverride: PropTypes.string,
  mapLocationData: PropTypes.func,
  hideMapInCompact: PropTypes.bool,
  searchType: PropTypes.string,
  displaySearchTop: PropTypes.bool,
  scrollToMain: PropTypes.bool,
  initialSelectedFilters: PropTypes.shape({
    sales: PropTypes.bool,
    service: PropTypes.bool,
    parts: PropTypes.bool
  }),
  locationState: PropTypes.shape({
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    postcode: PropTypes.postcode
  }),
  salesCTA: PropTypes.object,
  serviceCTA: PropTypes.object,
  emailCTA: PropTypes.object,
  locations: PropTypes.array,
  hideWhenNoLocation: PropTypes.bool,
  isMapFirstInCompact: PropTypes.bool,
  dropDownDisabled: PropTypes.bool,
  dropDownLabel: PropTypes.string,
  showScrollbars: PropTypes.bool,
  mapFixHeightStyle: PropTypes.object,
  search: PropTypes.object,
  gtmMapping: PropTypes.object,
  mapFixHeight: PropTypes.bool
}

MapLocationContainer.defaultProps = {
  defaultZoom: 17,
  disableFilters: false,
  displaySearchTop: true,
  onDealerChange: noop,
  mapLocationData: location => location, // because we need to change locations in outlet
  isMapFirstInCompact: true,
  scrollToMain: true,
  entryMessage: "",
  showScrollbars: true,
  autoSelectDealer: true,
  heading: "Find a Dealer",
  hideWhenNoLocation: true
}

export default withRadium(
  gtmEvent(),
  DetectCompact({ threshold: 768 }),
  ConnectLocation(),
  SearchParams({
    exposeParams: ["department", "dealerCode", "locationId", "step"]
  }),
  connect(state => ({
    globalHeaderHeight: selectors.getGlobalHeaderHeight(state)
  }))
)(MapLocationContainer)

const breakpointWide = "@media (min-width: 768px)"

const styles = {
  main: headerHeight => ({
    [breakpointWide]: {
      // height: `calc(100vh - ${headerHeight}px + 270px)`,
      minHeight: "650px"
    }
  }),
  detailItem: {
    fontWeight: 200,
    margin: ".5em 0",
    lineHeight: "1.4"
  },
  map: (isMapFirstInCompact, mapFixHeightStyle = { height: "100%" }) => ({
    flexDirection: isMapFirstInCompact ? "column" : "column-reverse",
    [breakpointWide]: {
      ...mapFixHeightStyle,
      flexDirection: "row"
    }
  }),
  detailsPanel: showScrollbars => ({
    display: "flex",
    flexDirection: "column",
    borderBottom: "1px solid rgb(213, 213, 213)",
    borderTop: "1px solid rgb(213, 213, 213)",
    [breakpointWide]: {
      flex: "0 0 50%",
      overflowY: showScrollbars ? "auto" : "hidden"
    }
  }),
  mapPanel: {
    alignSelf: "stretch",
    position: "relative",
    order: "-1",
    [breakpointWide]: {
      flex: "0 0 50%",
      order: "1"
    }
  },
  loaderContainer: {
    display: "flex",
    flex: "1 1 auto",
    justifyContent: "center",
    margin: "2em 0"
  },
  locationsAndMapContainer: { display: "flex", textAlign: "left" },
  locationsAndMapContainerCompactMode: { minHeight: "66vh" },
  mapBlockContainerCompact: { display: "block", minHeight: "50vh" },

  mapBlockContainerNotCompact: {
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    overflow: 'hidden'
  }
}



// WEBPACK FOOTER //
// ./src/containers/map-location/index.jsx